import * as React from 'react';
import * as UserModule from './../../Modules/UserModule';
import {connect} from 'react-redux';
import ReactTable from 'react-table';
import * as Dictionary from './../../Models/Dictionary';
import {withTranslation} from 'react-i18next';
import {checkPageQuery, injectThProps, UserStatus, Cell, Filter} from 'HelperFunctions/Lists';
import moment from 'moment';
import {CustomSort} from 'components/Map/VehiclesList/CustomFilterComponents';
import {createSerachQuery} from 'Connectors/_main';
import {TooltipFiltering} from '../Layout/Form/Fields/CustomFilterComponents';
import i18n from '../../Translations/_i18n';
import {Footer, InfinityReactTable, InfinityScrollParams} from "components/common/InfinityReactTable";
import * as InfinityTableModule from "Modules/InfinityTableModule";

type ConnectedDispatch = {
    getUserList: Function;
    blockUser: Function;
    unblockUser: Function;
    setActiveUser: (user: UserModule.Types.UserDto) => Function;
    setRoleFilter: (userRole: UserModule.UserEnumTypes.RoleName) => Function;
    t?: Function;
    setInfinityTableLoading: Function;
    setInfinityTableAllCounts: Function;
};

type ConnectedProps = {
    // userStore: UserModule.Types.UserStore;
    userRoleFilter: UserModule.UserEnumTypes.RoleName;
    userList: Array<UserModule.Types.UserDto>
};
type S = {
    selected: number;
    activeSorting: string;
    activeFilters: Array<{ id: string, value: any }>;
};

class UsersList extends React.PureComponent<ConnectedProps & ConnectedDispatch, S> {
    private optionList = [
        {
            value: UserModule.UserEnumTypes.Status.ACTIVE,
            label: i18n.t(`dictionary:${UserModule.UserEnumTypes.Status.ACTIVE}`),
            number: 1,
            img: Dictionary.UserStatusIcon.get(UserModule.UserEnumTypes.Status.ACTIVE)
        },
        {
            value: UserModule.UserEnumTypes.Status.BLOCKED,
            label: i18n.t(`dictionary:${UserModule.UserEnumTypes.Status.BLOCKED}`),
            number: 1,
            img: Dictionary.UserStatusIcon.get(UserModule.UserEnumTypes.Status.BLOCKED)
        },
        {
            value: UserModule.UserEnumTypes.Status.NOT_ACTIVE,
            label: i18n.t(`dictionary:${UserModule.UserEnumTypes.Status.NOT_ACTIVE}`),
            number: 1,
            img: Dictionary.UserStatusIcon.get(UserModule.UserEnumTypes.Status.NOT_ACTIVE)
        }
    ];

    private infinityScrollParams: InfinityScrollParams;

    constructor(props: ConnectedProps & ConnectedDispatch) {
        super(props);
        this.state = {
            selected: null,
            activeSorting: '',
            activeFilters: []
        };

        this.setActiveSorting = this.setActiveSorting.bind(this);
        this.getTrProps = this.getTrProps.bind(this);
        this.getUserListOrder = this.getUserListOrder.bind(this);

        this.infinityScrollParams = new InfinityScrollParams(30, React.createRef());
    }

    private personFilter = Filter.InputTextFilter.bind(this, this.props.t('firstOrLastName'), true);
    private emailFilter = Filter.InputTextFilter.bind(this, this.props.t('email'), true);
    private creationDateFilter = Filter.SortFilter.bind(this, this.props.t('creationDate'));
    private statusFilter = Filter.TooltipFilter.bind(this, this.props.t('Status'));


    private checkPageQueryLocal(tableFiltered: Array<{ id: string; value: any }>, statePage: any, itemsPerLoad: number, itemsFirstLoad: number) {
        const tempFiltered = tableFiltered || [];

        const tempFilteredFindUserRoleIndex = tempFiltered.findIndex((el: { id: string; value: any }) => {
            return el.id == 'userRole';
        });

        if (tempFilteredFindUserRoleIndex != -1) {
            tempFiltered[tempFilteredFindUserRoleIndex].value = this.props.userRoleFilter;
        } else {
            tempFiltered.push({
                id: 'userRole',
                value: this.props.userRoleFilter
            });
        }

        return checkPageQuery(tempFiltered, statePage, itemsPerLoad, itemsFirstLoad);
    }

    private async getUserListOrder(state = {}, scrollLoad: boolean = false) {
        const {activeFilters, currentPage, itemsPerLoad, itemsFirstLoad} = this.infinityScrollParams.prepareLoadParams(state, scrollLoad);

        this.props.setInfinityTableLoading(true);

        //***** Naprawa błędnego filtrowania razem z sortowaniem
        Filter.FilterSortingFix.call(this, activeFilters);
        //******

        // żeby nie wysłać przypadkiem jakiegoś pustego filtra tylko jak ma jakieś value przypisane
        const activeFiltersPrepared = activeFilters.filter(element => element.value);

        const query = this.checkPageQueryLocal(
            activeFiltersPrepared,
            currentPage,
            itemsPerLoad,
            itemsFirstLoad
        );

        const params = createSerachQuery(query);
        await this.props.getUserList(params, !scrollLoad);

        this.props.setInfinityTableLoading(false);

        this.setState({
            activeFilters: activeFiltersPrepared,
        });
    }

    private userListHeadingdata: Array<{ roleName: UserModule.UserEnumTypes.RoleName; onClick: Function }> = [
        {
            roleName: UserModule.UserEnumTypes.RoleName.ADMIN,
            onClick: async () => {
                await this.props.setRoleFilter(UserModule.UserEnumTypes.RoleName.ADMIN);
                this.getUserListOrder();
            }
        },
        {
            roleName: UserModule.UserEnumTypes.RoleName.FLEET_OWNER,
            onClick: async () => {
                await this.props.setRoleFilter(UserModule.UserEnumTypes.RoleName.FLEET_OWNER);
                this.getUserListOrder();
            }
        },
        {
            roleName: UserModule.UserEnumTypes.RoleName.TECHNICIAN,
            onClick: async () => {
                await this.props.setRoleFilter(UserModule.UserEnumTypes.RoleName.TECHNICIAN);
                this.getUserListOrder();
            }
        },
        {
            roleName: UserModule.UserEnumTypes.RoleName.EXTERNAL,
            onClick: async () => {
                await this.props.setRoleFilter(UserModule.UserEnumTypes.RoleName.EXTERNAL);
                this.getUserListOrder();
            }
        }
    ];
    private getTrProps = (state, rowInfo: { original: UserModule.Types.UserDto; [name: string]: any }, column) => {
        const trClass = rowInfo && rowInfo.index === this.state.selected ? 'active' : '';
        return {
            onClick: () => {
                this.setState({selected: rowInfo.index});
                this.props.setActiveUser(rowInfo.original);
            },
            className: trClass
        };
    };

    private setActiveSorting(e: any, colId: string, onChange: Function) {
        this.setState({
                activeSorting: colId
            }, () => onChange(e)
        );
    }

    public componentDidMount(): void {
        // resetuję countery w footerze inifinity scroll tabla (userTable nie ma np. total count i by się mogły wyświetlać wartości z innych tabel)
        this.props.setInfinityTableAllCounts(0, null);
    }

    public render() {
        const userList = this.props.userList;
        const userRoleFilter = this.props.userRoleFilter;
        const {t} = this.props;
        const {activeSorting} = this.state;
        return (
            <>
                <ul className="tabs">
                    {this.userListHeadingdata.map((e: { roleName: UserModule.UserEnumTypes.RoleName; onClick: Function }, idx: any) => {
                        return (
                            <li className={`tabs__item ${userRoleFilter == e.roleName ? 'tabs__item--active' : ''}`}
                                key={idx} onClick={() => e.onClick()}>
                                {t(`dictionary:${e.roleName}`)}
                            </li>
                        );
                    })}
                </ul>
                <div className="table__content table__content--with-role">
                    <InfinityReactTable
                        data={...userList}
                        getTrProps={this.getTrProps}
                        columns={this.renderColumns(t)}
                        onFetchData={this.getUserListOrder}
                        waypointRef={this.infinityScrollParams.getWaypointRef()}
                        defaultPageSize={this.infinityScrollParams.getItemsFirstLoad()}
                        activeId={this.state.selected}
                    />
                </div>

                <Footer/>
            </>
        );
    }

    // TODO: ogarnąć tutaj filtry w całości na wzór np. email (czyli przekazana ref do metody w tej klasie)
    private renderColumns(t) {
        return [
            {
                //Header: t('firstName'),
                id: 'fullName',
                accessor: 'firstName',
                Header: 'hiddenHeader',
                className: 'cell',
                maxWidth: 270,
                Cell: props => {
                    return (
                        <>
                            <div className="cell__half overflow-wrapper">
                            <span className="cell__cut-text" title={props.original.firstName}>
                                {props.original.firstName}
                            </span>
                            </div>
                            <div className="cell__half overflow-wrapper">
                            <span className="cell__cut-text" title={props.original.lastName}>
                                {props.original.lastName}
                            </span>
                            </div>
                        </>
                    );
                },
                Filter: this.personFilter
            },
            {
                Header: 'hiddenHeader',
                id: 'email',
                className: 'cell',
                accessor: 'email',
                Cell: Cell.CutTextCell,
                Filter: this.emailFilter
            },
            {
                Header: 'hiddenHeader',
                id: 'accountingEmail',
                className: 'cell',
                accessor: 'accountingEmail',
                Cell: Cell.CutTextCell,
                show: this.props.userRoleFilter == UserModule.UserEnumTypes.RoleName.FLEET_OWNER,
                Filter: ({filter, onChange}) => <div className="filter__title">{this.props.t('accountingEmail')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'phoneNumber',
                className: 'cell',
                accessor: 'phoneNumber',
                maxWidth: 100,
                Filter: ({filter, onChange}) => <div className="filter__title">{this.props.t('phone')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'city',
                className: 'cell',
                accessor: 'city',
                Cell: Cell.CutTextCell,
                maxWidth: 100,
                show: this.props.userRoleFilter == UserModule.UserEnumTypes.RoleName.TECHNICIAN,
                Filter: ({filter, onChange}) => <div className="filter__title">{this.props.t('city')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'insuranceEndDate',
                className: 'cell',
                accessor: 'insuranceEndDate',
                show: this.props.userRoleFilter == UserModule.UserEnumTypes.RoleName.TECHNICIAN,
                Cell: props => (props.value ? moment(props.value).format('DD.MM.YYYY') : '-'),
                Filter: ({filter, onChange}) => <div
                    className="filter__title">{this.props.t('insurancePolicyEndDate')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'companyName',
                className: 'cell',
                accessor: 'companyName',
                show: this.props.userRoleFilter == UserModule.UserEnumTypes.RoleName.TECHNICIAN,
                Cell: Cell.CutTextCell,
                Filter: ({filter, onChange}) => <div className="filter__title">{this.props.t('company')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'status',
                accessor: 'status',
                className: 'cell cell__terminal-status',
                maxWidth: 130,
                Cell: props => <UserStatus userData={props} t={this.props.t}/>,
                Filter: this.statusFilter
            },
            {
                Header: 'hiddenHeader',
                id: 'creationDate',
                className: 'cell',
                accessor: 'creationDate',
                maxWidth: 150,
                Cell: props => moment(props.value).format('HH:MM:SS, DD.MM.YYYY'),
                Filter: this.creationDateFilter
            }
        ];
    }
}

export class FooterTest extends React.PureComponent<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            count: 0
        }
    }

    private clickBtn = () => {
        this.setState({
            count: this.state.count + 1
        });
    }

    public render() {
        console.log('t3st', this.props);
        return <h1 onClick={this.clickBtn}>TEst {this.state.count} </h1>
    }
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        getUserList: (queryParams?: Array<{ key: any; value: any }>, filterQuery?: boolean) => dispatch(UserModule.Actions.getUserList(queryParams ? queryParams : null, filterQuery)),
        blockUser: (userId: number) => dispatch(UserModule.Actions.blockUser(userId)),
        unblockUser: (userId: number) => dispatch(UserModule.Actions.unblockUser(userId)),
        setActiveUser: (user: UserModule.Types.UserDto) => dispatch(UserModule.Actions.setActiveUser(user)),
        setRoleFilter: (userRole: UserModule.UserEnumTypes.RoleName) => dispatch(UserModule.Actions.setUserRoleFilter(userRole)),
        setInfinityTableLoading: (value: boolean) => dispatch(InfinityTableModule.Actions.setInfinityTableLoading(value)),
        setInfinityTableAllCounts: (count: number, totalCount: number) => dispatch(InfinityTableModule.Actions.setInfinityTableAllCounts(count, totalCount))
    };
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        userRoleFilter: state.userStore.userRoleFilter,
        userList: state.userStore.userList
    };
}

export default withTranslation(['forms', 'tables', 'dictionary'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(UsersList) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/UserManagement/UsersList.tsx